/**
 * Application Entry Point
 * Renders the root App component
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';
import './index.css';
import { captureReferralFromUrl } from './utils/referralCapture';

captureReferralFromUrl();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
